/** Polygon 只读 RPC（浏览器直连；勿用 rpc.ankr.com / polygon-rpc.com；PROD 勿用 publicnode） */

export const DEFAULT_POLYGON_RPC_URL = 'https://polygon-bor.publicnode.com';

const BLOCKED_RPC_HOSTS = ['rpc.ankr.com', 'polygon-rpc.com', 'ankr.com'];
/** PROD 禁止作为主 RPC（易 429）；开发环境仍可兜底 */
const THROTTLED_RPC_HOSTS = ['publicnode.com'];

export function isBlockedPolygonRpc(url) {
  const value = String(url ?? '')
    .trim()
    .toLowerCase();
  if (!value) return true;
  return BLOCKED_RPC_HOSTS.some((host) => value.includes(host));
}

export function isThrottledPolygonRpc(url) {
  const value = String(url ?? '')
    .trim()
    .toLowerCase();
  if (!value) return false;
  return THROTTLED_RPC_HOSTS.some((host) => value.includes(host));
}

/** 余额等只读查询用的 RPC 列表（按优先级，最多 2 个） */
export function getPolygonReadRpcUrls() {
  const fromEnv = String(process.env.VUE_APP_CHAIN_RPC ?? '').trim();
  const urls = [];
  const isProd = process.env.NODE_ENV === 'production';

  // 开发环境走 devServer 代理，避免浏览器跨域 / 代理软件干扰
  if (process.env.NODE_ENV === 'development') {
    urls.push('/polygon-rpc');
  } else if (
    fromEnv &&
    !isBlockedPolygonRpc(fromEnv) &&
    !(isProd && isThrottledPolygonRpc(fromEnv))
  ) {
    urls.push(fromEnv);
  }

  if (
    fromEnv &&
    !isBlockedPolygonRpc(fromEnv) &&
    !(isProd && isThrottledPolygonRpc(fromEnv)) &&
    !urls.includes(fromEnv)
  ) {
    urls.push(fromEnv);
  }

  // PROD：禁止静默回落 publicnode；须构建时注入付费 VUE_APP_CHAIN_RPC
  if (!urls.length) {
    if (!isProd) {
      urls.push(DEFAULT_POLYGON_RPC_URL);
    }
  } else if (
    !isProd &&
    urls.length === 1 &&
    !urls.includes(DEFAULT_POLYGON_RPC_URL)
  ) {
    urls.push(DEFAULT_POLYGON_RPC_URL);
  }

  return [...new Set(urls)].slice(0, 2);
}

export function getPolygonPrimaryRpcUrl() {
  return getPolygonReadRpcUrls()[0] || DEFAULT_POLYGON_RPC_URL;
}

function isAbsoluteHttpUrl(url) {
  return /^https?:\/\//i.test(String(url ?? '').trim());
}

/** 将相对路径 / 非 HTTP URL 规范为可外链的绝对 RPC 地址 */
export function resolveAbsolutePolygonRpcUrl(url) {
  const value = String(url ?? '').trim();
  const isProd = process.env.NODE_ENV === 'production';
  if (
    value &&
    !value.startsWith('/') &&
    isAbsoluteHttpUrl(value) &&
    !isBlockedPolygonRpc(value) &&
    !(isProd && isThrottledPolygonRpc(value))
  ) {
    return value;
  }
  const fromEnv = String(process.env.VUE_APP_CHAIN_RPC ?? '').trim();
  if (
    fromEnv &&
    !fromEnv.startsWith('/') &&
    isAbsoluteHttpUrl(fromEnv) &&
    !isBlockedPolygonRpc(fromEnv) &&
    !(isProd && isThrottledPolygonRpc(fromEnv))
  ) {
    return fromEnv;
  }
  // PROD 无可用付费 RPC 时仍返回默认值供 WalletConnect 绝对 URL，但 getPolygonReadRpcUrls 不会用它做主读
  return DEFAULT_POLYGON_RPC_URL;
}

/** WalletConnect 等外部协议要求绝对 HTTP URL，不可用 dev 代理路径 /polygon-rpc */
export function getPolygonWalletRpcUrl() {
  return resolveAbsolutePolygonRpcUrl(process.env.VUE_APP_CHAIN_RPC);
}
